import request from 'utils/request';
import configs from 'configs';

export async function logout (params) {
  return request({
    url: configs.logoutUrl,
    method: 'get',
    data: params,
  });
}

export async function getUserProfile (params) {
  return request({
    url: configs.userProfileUrl,
    method: 'get',
    data: params,
  });
}

export async function getSpaceToken (params) {
  return request({
    url: configs.spaceTokenUrl,
    method: 'get',
    data: params,
    showError: false,
  });
}

export async function getListSpaces (params) {
  return request({
    url: configs.listSpacesUrl,
    method: 'get',
    data: params,
    slugs: ['spaces.name'],
  });
}

export async function getUsersInSpace (params) {
  return request({
    url: configs.spaceUsersUrl,
    method: 'get',
    data: params,
  });
}

export async function getSpaceSettings (params) {
  return request({
    url: '/settings/space-settings',
    method: 'get',
    data: params,
  });
}

export async function getPaymentData (params) {
  return request({
    url: `${configs.authApiUrl}/me/current-space/payment`,
    method: 'get',
    data: params,
  });
}

export async function getBillingData (params) {
  return request({
    url: '/spaces/current/billing',
    method: 'get',
    data: params,
  });
}



// WEBPACK FOOTER //
// ./src/services/app.js